const StepsTipo = {
    data: {
        ERROR: 19,
        simulador: {
            TERMINO_SIMULADOR_SEGUROS: 21,
            TERMINO_SIMULADOR_CUOTAS: 22,
            INICIO_SIMULADOR_CUOTA: 23,
            INICIO_SIMULADOR_SEGURO: 42,
            VOLVER_A_SIMULAR: 24,
        },
        VALIDAR_STEP_ACTUAL: 20,
        INICIO_FORMALIZAR_CREDITO: 72,
        FORMALIZAR_CREDITO: 73,
        cursar: {
            INICIO_CURSAR_CREDITO: 74,
            CURSAR_CREDITO: 75,
            ERROR_CURSAR: 6541000000,
            SET: 53
        },
        documentos: {
            INICIO_OBTENER_DOCUMENTOS_1: 91,
            GUARDAR_DOCUMENTO_1: 92,
            INICIO_OBTENER_DOCUMENTOS_2: 93,
            GUARDAR_DOCUMENTO_2: 94,
            INICIO_OBTENER_DOCUMENTOS_3: 95,
            GUARDAR_DOCUMENTO_3: 96,
            INICIO_OBTENER_DOCUMENTOS_4: 97,
            GUARDAR_DOCUMENTO_4: 98,
            INICIO_OBTENER_DOCUMENTOS_5: 99,
            GUARDAR_DOCUMENTO_5: 100,
            INICIO_OBTENER_DOCUMENTOS_6: 101,
            GUARDAR_DOCUMENTO_6: 102,
            INICIO_OBTENER_DOCUMENTOS_7: 103,
            GUARDAR_DOCUMENTO_7: 104,
            INICIO_OBTENER_DOCUMENTOS_8: 105,
            GUARDAR_DOCUMENTO_8: 106,
            ERROR: 34098742679
        },
        coordenadas: {
            INICIO_OBTENER_DESAFIO: 200,
            GUARDAR_COORDENADAS: 201,
            ERROR_COORDENADAS: 985023212
        },
        autorizar: {
            INICIO_AUTORIZACION: 15,
            AUTORIZAR: 16,
            OBTENER: 18,
            ERROR: 7541000000
        },
        seguros: {
            BUSCA_SEGUROS: 'BUSCA_SEGUROS',
            OBTIENE_SEGUROS: 'OBTIENE_SEGUROS',
            SELECION_SEGURO: 'SELECION_SEGURO',
            ERROR: 'ERROR'
        }
    }
};
export default StepsTipo;